import { render, staticRenderFns } from "./LeaveRequestApproved.vue?vue&type=template&id=0223030a"
import script from "./LeaveRequestApproved.vue?vue&type=script&lang=js"
export * from "./LeaveRequestApproved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports